import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-search-results-table',
  templateUrl: './search-results-table.component.html',
  styleUrls: ['./search-results-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SearchResultsTableComponent extends BaseComponent implements OnInit, OnDestroy {
   
    @Input() dataSource: any[] = [];
    @Input() searchTerm: string;
    @Input() searchPressed: boolean;
    @Input() displayProgressSpinner: boolean;
    displayedColumns: string[] = ['purpose'];

    constructor(
        private injector: Injector,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    recordsFound(): boolean {
        return this.dataSource && this.dataSource.length > 0 ? true : false;
    }
    
    isPublication(record: any): boolean {
        return  record._index === DatabaseIndexNameType.publication ? true : false;
    }

    isPublicationPdf(record: any): boolean {
        return  record._index === DatabaseIndexNameType.publication_pdf ? true : false;
    }

    isAssessment(record: any): boolean {
        return  record._index === DatabaseIndexNameType.assessment ? true : false;
    }

    isAssessmentPdf(record: any): boolean {
        return  record._index === DatabaseIndexNameType.assessment_pdf ? true : false;
    }

    isDrillHole(record: any): boolean {
        return  record._index === DatabaseIndexNameType.drillHoles ? true : false;
    }

    isMineralInventory(record: any): boolean {
        return  record._index === DatabaseIndexNameType.mineralInventory ? true : false;
    }

    isAbandonedMine(record: any): boolean {
        return  record._index === DatabaseIndexNameType.abandonedMines ? true : false;
    }

}
